import useRouteName from "./useRouteName.js";
const useIsPostBookingRoute = () => {
    const routeName = useRouteName();
    return routeName.startsWith("pb-") || routeName === "confirmation";
};
export default useIsPostBookingRoute;
